import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { s as slotFilled } from './p-rUtJRH95.js';
import { d as defineCustomElement$8 } from './p-C_esi8gV.js';
import { d as defineCustomElement$7 } from './p-CkgLRZPl.js';
import { d as defineCustomElement$6 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$5 } from './p-C3Ej010A.js';
import { d as defineCustomElement$4 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$3 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

const inputMenuCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:1;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}wui-input-button [slot=prefix-icon]{display:inline-flex}";

const WuiInputMenu = /*@__PURE__*/ proxyCustomElement(class WuiInputMenu extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.clear = createEvent(this, "clear", 3);
        this.openChanged = createEvent(this, "openChanged", 3);
        /**
         * If disabled
         */
        this.disabled = false;
        /**
         * If content is loading
         */
        this.loading = false;
        /**
         * If menu is open
         */
        this.open = false;
        this.alignment = 'start';
    }
    async _handleKeyDown(e) {
        const wuiMenuPaneElement = this.elm.shadowRoot?.querySelector('wui-menu-pane');
        if (wuiMenuPaneElement && (await wuiMenuPaneElement.handleKeyDown(e))) {
            // Event was handled by menu pane
            this.toggleOpen(!!wuiMenuPaneElement.open);
            return;
        }
        const wuiListElement = this.elm.shadowRoot?.querySelector('wui-list');
        if (wuiListElement && (await wuiListElement.handleKeyDown(e))) {
            return;
        }
    }
    toggleOpen(open = !this.open) {
        if (open === this.open) {
            return;
        }
        this.open = open;
        this.openChanged.emit(this.open);
    }
    render() {
        return (h(Host, { key: '50a2442460f1fa88c20c28f7670e8f2d4256ad34' }, h("wui-input-button", { key: 'f5699cd2a6ecd705ccb1ee3f7094d6fae4651b6a', loading: this.loading, disabled: this.disabled || this.loading, open: this.open, onClear: (e) => {
                // We're going to emit the event again in this component, so stop the inner event
                // from bubbling upwards
                e.preventDefault();
                e.stopPropagation();
                // Emit the event again
                this.clear.emit();
            }, onClick: () => {
                this.open = !this.open;
            }, onBlur: (e) => {
                if (e.relatedTarget && e.relatedTarget instanceof H && this.elm.contains(e.relatedTarget)) {
                    // Don't fire blur event when focus is still inside of this component
                    e.stopPropagation();
                }
            }, ...this.inputButton }, slotFilled(this.elm, 'prefix-icon') && h("slot", { key: '0f307aa784c939b05be48f5bec34b7a0caae1246', name: "prefix-icon", slot: "prefix-icon" })), h("wui-menu-pane", { key: '317826546dc55d896f84cda638ebbd1f0971ba24', open: this.open, onClickOutside: () => {
                this.toggleOpen(false);
            }, onOpenChanged: (e) => {
                this.toggleOpen(e.detail);
            }, placement: `bottom-${this.alignment ?? 'start'}`, stretch: "min", ...this.menuPane }, h("slot", { key: 'd1b70d12b87ac19261f7d9a0e697c2211eaeeb0e' }))));
    }
    get elm() { return this; }
    static get style() { return inputMenuCss; }
}, [257, "wui-input-menu", {
        "disabled": [516],
        "loading": [516],
        "inputButton": [16, "input-button"],
        "menuPane": [16, "menu-pane"],
        "open": [1540],
        "alignment": [1]
    }, [[0, "keydown", "_handleKeyDown"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-input-menu", "wui-badge", "wui-close-button", "wui-icon", "wui-input-button", "wui-loader", "wui-menu-pane", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-input-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiInputMenu);
            }
            break;
        case "wui-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-input-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiInputMenu as W, defineCustomElement as d };
